import React, { useEffect, useRef, useState } from "react";
import { classRoom } from "../../../core/data/json/class-room";
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";
import {
  capacitycount,
  count,
} from "../../../core/common/selectoption/selectoption";
import CommonSelect from "../../../core/common/commonSelect";
import { Link, useParams } from "react-router-dom";
import TooltipOption from "../../../core/common/tooltipOption";
import { all_routes } from "../../router/all_routes";
import UserService from "../../network/services/UserService";
import { Modal, Toast } from "react-bootstrap";
import { getUser } from "../../network/auth/Auth";
import { DatePicker } from "antd";

const ClassRoomDetails = () => {


  interface AdmissionData {
    id: any;
    name: any;
    application_number: any;
    state: any;
    admission_date: false,
    application_date: any;
    student_id: any;
    register_id: any;
    course_id: any;

  }
  interface Option {
    id: any;
    name: any;
  }



  interface CourseData {
    id: any;
    name: any;
    code: any;
    parent_id: any;
    evaluation_type: any;
    subject_ids: any;
    department_id: any;
    active: any;
    fees_term_id: any;
    operating_branch_id: any;
    company_id: any

  }

  interface AcademyYearData {
    id: any;
    name: any;
    start_date: any;
    end_date: any;
    academic_term_ids: any;
    term_structure: any;
    company_id: any;
  }
  interface CourseFeesData {
    id: any;
    name: any;
    standard_price: any;
    lst_price: any;
    detailed_type: any,
    company_id: any

  }

  interface AcademyTermData {
    id: any;
    name: any;
    term_start_date: any;
    term_end_date: any;
    academic_term_ids: any;
    term_structure: any;
    company_id: any;

  }

  interface OptionType {
    id: any;
    name: any;
  }


  const [isActionSuccessful, setIsActionSuccessful] = useState(false);
  const [isActionSuccessfulEdit, setIsActionSuccessfulEdit] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showDangerToast, setShowDangerToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<any>({
    first_name: '',
    last_name: '',
    email: '',
    gender: '',
    birth_date: '',
    register_id: '',
    fees_term_id: '',
    classroom_id: '',
    middle_name: '',
    course_id: '',
    operating_branch_id: '',
    company_id: ''
  });




  const handleSuccessToastClose = () => {
    setShowSuccessToast(false);
  };

  const handleDangerToastClose = () => {
    setShowDangerToast(false);
  };

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const handleClose2 = () => setShowModal2(false);
  const handleShow2 = () => setShowModal2(true);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowDangerToast(false);
    }, 3000);
    return () => clearTimeout(timeoutId);
  }, [showDangerToast]);


  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowSuccessToast(false);
    }, 4000);
    return () => clearTimeout(timeoutId);
  }, [showSuccessToast]);

  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    gender: '',
    birth_date: '',
    register_id: '',
    fees_term_id: '',
    classroom_id: '',
    middle_name: '',
    course_id: '',
    operating_branch_id: '',
    company_id: ''
  });

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });


    console.log(value);
    fetchDataOpBatchs(value)
  };

  const handleInputChangeEdite = (e: any) => {
    const { name, value } = e.target;
    setSelectedRecord((prevRecord: any) => ({
      ...prevRecord,
      [name]: value
    }));
  };

  const handleInputChangeEdite2 = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = event.target;
    const selectedBranch = branches.find((branch: any) => branch.id === parseInt(value, 10));

    if (selectedBranch) {
      setSelectedRecord((prevState: any) => ({
        ...prevState,
        operating_branch_id: [selectedBranch],
      }));
    }
  };

  const handleInputChangeEdite3 = (selectedOptions: any) => {
    if (selectedOptions) {
      const selectedSubjects = selectedOptions.map((option: any) => ({
        id: option.value,
        name: option.label,
      }));

      setSelectedRecord((prevState: any) => ({
        ...prevState,
        subject_ids: selectedSubjects,
      }));
    } else {
      setSelectedRecord((prevState: any) => ({
        ...prevState,
        subject_ids: [],
      }));
    }
  };



  const handleSelectChange = (selectedOption: any, actionMeta: any) => {

    setFormData({
      ...formData,
      [actionMeta.name]: selectedOption
    });
  };


  const [multiSubject, setMultiSubject] = useState<OptionType[]>([]);

  const handleEdit = (record: any) => {
    setSelectedRecord(record)
    handleShow2()
    console.log(record)

  };


  const formatDate = (date: Date | string) => {
    if (!date) return '';

    const d = new Date(date);
    const month = `${d.getMonth() + 1}`.padStart(2, '0');
    const day = `${d.getDate()}`.padStart(2, '0');
    const year = d.getFullYear();

    return `${year}-${month}-${day}`;
  };




  interface PartnerTitleData {
    id: any;
    name: any;
    shortcut: any;
  }


  interface OpFeesTermData {
    id: any;
    name: any;
  }

  interface OpBatchData {
    id: any;
    name: any;
  }

  interface AdmissionData2 {
    name: any,
    state: any,
    start_date: any,
    end_date: any,
    max_count: any,
    min_count: any,
    product_id: any,
    company_id: any,
    course_id: any,
    minimum_age_criteria: any,
    operating_branch_id: any,
    academic_term_id: any,
    academic_years_id: any,
  }


  const [Admissions, setAdmissions] = useState<AdmissionData[]>([]);
  const [admission, setAdmission] = useState<AdmissionData2>();
  const [partnerTitle, setPartnerTitle] = useState<PartnerTitleData[]>([]);
  const [opbatchs, setOpbatchs] = useState<OpBatchData[]>([]);
  const [opFeesTerms, setOpFeesTerms] = useState<OpFeesTermData[]>([]);
  const [branch, setBranch] = useState<Option>(getUser()?.company_ids[0]?.branches[0]);
  const branches = getUser()?.company_ids[0]?.branches;



  const fetchDataRestPartnerTitle = async () => {

    UserService.getRestPartnerTitle((response: any) => {
      if (response?.data && response?.success) {
        setPartnerTitle(response.data);

      }
    });
  };


  const fetchDataOpBatchs = async (course_id: any) => {
    UserService.getOpBatch(course_id, (response: any) => {
      if (response?.data && response?.success) {
        setOpbatchs(response.data);
      }
    });
  };


  const fetchDataOpFeesTerm = async (company_id: any) => {

    UserService.getOpFeesTerm(company_id, (response: any) => {
      if (response?.data && response?.success) {
        setOpFeesTerms(response.data);
        setIsLoading(false)

      }
    });
  };


  /*   const fetchData = async (admission_id: any) => {
      setIsLoading(true)
      UserService.getApplicationAdmission(admission_id, (response: any) => {
        if (response?.data && response?.success) {
          setAdmissions(response.data);
          console.log(response.data)
          setIsLoading(false)
  
        } else {
          setIsLoading(false)
        }
      });
    };
   */
  const fetchDataAdmissionDetails = async (admission_id: any) => {
    setIsLoading(true)
    UserService.getOneAdmission(admission_id, (response: any) => {
      if (response?.data && response?.success) {
        setAdmission(response.data[0]);
        console.log(response.data[0])
        setIsLoading(false)

      } else {
        setIsLoading(false)
      }
    });
  };

  useEffect(() => {

    //fetchData(admissionId);
    // fetchDataAdmissionDetails(admissionId);
    fetchDataRestPartnerTitle()
  }, []);


  const [courses, setCourses] = useState<CourseData[]>([]);

  const fetchDataCourse = async (company_id: any) => {
    UserService.getCourseByBranchAndComapny2(company_id, (response: any) => {
      if (response?.data && response?.success) {
        setCourses(response.data);
      }
    });
  };


  useEffect(() => {
    fetchDataCourse(getUser()?.company_ids[0]?.id);
    fetchDataOpFeesTerm(getUser()?.company_ids[0]?.id);
  }, []);

  const [academyYears, setAcademyYears] = useState<AcademyYearData[]>([]);
  const fetchDataAcademicYear = async (company_id: any) => {
    UserService.getAcademyYear2(company_id, (response: any) => {
      if (response?.data && response?.success) {
        setAcademyYears(response.data);
      }
    });
  };

  useEffect(() => {
    fetchDataAcademicYear(getUser()?.company_ids[0]?.id);

  }, []);


  const [academyTerms, setAcademyTerms] = useState<AcademyTermData[]>([]);

  const fetchDataAcademicTerm = async (company_id: any) => {
    UserService.getAcademyTerm2(company_id, (response: any) => {
      if (response?.data && response?.success) {
        setAcademyTerms(response.data);
      }
    });
  };

  useEffect(() => {
    fetchDataAcademicTerm(getUser()?.company_ids[0]?.id);
  }, []);


  const [coursesFees, setCoursesFees] = useState<CourseFeesData[]>([]);
  const [admissionRegisters, setAdmissionRegisters] = useState<any>([]);


  const fetchDataAdmissionRegisterByCourse = async (id: any) => {
    UserService.getAdmissionRegisterByCourse(id, (response: any) => {
      if (response?.data && response?.success) {
        setAdmissionRegisters(response.data);
      }
    });
  };
  const fetchDataCourseFees = async (company_id: any) => {
    UserService.getCourseFees(company_id, (response: any) => {
      if (response?.data && response?.success) {
        setCoursesFees(response.data);
      }
    });
  };

  useEffect(() => {
    fetchDataCourseFees(getUser()?.company_ids[0]?.id);
  }, []);

  useEffect(() => {
    if (classroom?.course_id) {
      fetchDataAdmissionRegisterByCourse(classroom?.course_id)
    }

  }, []);


  const handleSubmit = () => {
    setIsLoading(true)

    const request_data = {
      first_name: formData.first_name,
      last_name: formData.last_name,
      email: formData.email,
      gender: formData.gender,
      birth_date: formData.birth_date,
      register_id: parseInt(formData.register_id, 10),
      fees_term_id: parseInt(formData.fees_term_id, 10),
      course_id: parseInt(classroom?.course_id, 10),
      classroom_id: parseInt(classroom?.id, 10),
      company_id: parseInt(classroom?.company_id, 10),
      operating_branch_id: parseInt(classroom?.operating_branch_id, 10),

    };
    console.log(request_data)
    UserService.addAdmissionAndAssignInClassroom(request_data, (response: any) => {
      if (response.success === true) {
        fetchData(parseInt(classroom?.id, 10))
        setIsLoading(false)
        setSuccessMessage('Data saved successfully')
        setShowSuccessToast(true)
        setFormData({
          first_name: '',
          last_name: '',
          email: '',
          gender: '',
          birth_date: '',
          register_id: '',
          fees_term_id: '',
          classroom_id: '',
          middle_name: '',
          course_id: '',
          operating_branch_id: '',
          company_id: ''
        });

        setShowModal(false);

      } else {
        setErrorMessage(response?.message)
        setShowDangerToast(true)
        setIsLoading(false)
      }
    });
  };















  const routes = all_routes;
  const { id } = useParams();
  const classroomId = id;


  interface classroomData {
    id: any,
    name: any,
    code: any,
    batch_id: any,
    course_id: any,
    company_id: any,
    operating_branch_id: any,
    active: any,
    student_assignments: any,
    admission_id: any,
    student_name: any,
    student_gender: any,
    assignment_date: any,
  }


  const [classrooms, setClassrooms] = useState<classroomData[]>([]);
  const [classroom, setClassroom] = useState<classroomData>();

  const fetchData = async (classroom_id: any) => {
    UserService.getDetailsClassroom(classroom_id, (response: any) => {
      if (response?.data && response?.success) {
        console.log(response.data?.student_assignments)
        setClassroom(response.data);
        setClassrooms(response.data?.student_assignments);
      }
    });
  };

  useEffect(() => {
    fetchData(classroomId)
  }, [])

  const data = classRoom;
  const columns = [
    {
      title: "Admission ID",
      dataIndex: "admission_id",
      render: (text: string, record: any, index: number) => (
        <>
          <Link to="#" className="link-primary">
            {record.admission_id}
          </Link>
        </>
      ),
      sorter: (a: classroomData, b: classroomData) => a.admission_id.length - b.admission_id.length,
    },

    {
      title: "Student Name",
      dataIndex: "student_name",
      sorter: (a: classroomData, b: classroomData) => a.student_name.length - b.student_name.length,
    },
    {
      title: "Student Gender",
      render: (record: any) => (
        <span>{record?.student_gender === "m" ? "Male" : "Female"}</span>
      )
    },
    {
      title: "Assignment Date",
      dataIndex: "assignment_date",
      sorter: (a: classroomData, b: classroomData) => a.assignment_date.length - b.assignment_date.length,
    },



    {
      title: "Action",
      dataIndex: "action",
      render: () => (
        <>
          <div className="dropdown">
            <Link
              to="#"
              className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="ti ti-dots-vertical fs-14" />
            </Link>
            <ul className="dropdown-menu dropdown-menu-right p-3">
              <li>
                <Link
                  className="dropdown-item rounded-1"
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#edit_class_room"
                >
                  <i className="ti ti-edit-circle me-2" />
                  Edit
                </Link>
              </li>
              <li>
                <Link
                  className="dropdown-item rounded-1"
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#delete-modal"
                >
                  <i className="ti ti-trash-x me-2" />
                  Delete
                </Link>
              </li>
            </ul>
          </div>
        </>
      ),
    },
  ];
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };

  return (
    <div>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
              <div className="my-auto mb-2">
                <h3 className="page-title mb-1">Class </h3>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={routes.adminDashboard}>Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="#">Academic </Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Class
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
                <TooltipOption />
                <div className="mb-2">
                  <Link
                    to="#"
                    className="btn btn-primary"
                    onClick={handleShow}
                  >
                    <i className="ti ti-square-rounded-plus-filled me-2" />
                    Add Students
                  </Link>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            {/* Guardians List */}
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
                <h4 className="mb-3">Class ({classroom?.name} - {classroom?.batch_id?.name})</h4>
                <div className="d-flex align-items-center flex-wrap">
                  <div className="input-icon-start mb-3 me-2 position-relative">
                    <PredefinedDateRanges />
                  </div>
                  <div className="dropdown mb-3 me-2">
                    <Link
                      to="#"
                      className="btn btn-outline-light bg-white dropdown-toggle"
                      data-bs-toggle="dropdown"
                      data-bs-auto-close="outside"
                    >
                      <i className="ti ti-filter me-2" />
                      Filter
                    </Link>
                    <div
                      className="dropdown-menu drop-width"
                      ref={dropdownMenuRef}
                    >
                      <form>
                        <div className="d-flex align-items-center border-bottom p-3">
                          <h4>Filter</h4>
                        </div>
                        <div className="p-3 border-bottom pb-0">
                          <div className="row">
                            <div className="col-md-12">
                              <div className="mb-3">
                                <label className="form-label">Room No</label>
                                <CommonSelect
                                  className="select"
                                  options={count}
                                />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="mb-3">
                                <label className="form-label">Capacity</label>
                                <CommonSelect
                                  className="select"
                                  options={capacitycount}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="p-3 d-flex align-items-center justify-content-end">
                          <Link to="#" className="btn btn-light me-3">
                            Reset
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-primary"
                            onClick={handleApplyClick}
                          >
                            Apply
                          </Link>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="dropdown mb-3">
                    <Link
                      to="#"
                      className="btn btn-outline-light bg-white dropdown-toggle"
                      data-bs-toggle="dropdown"
                    >
                      <i className="ti ti-sort-ascending-2 me-2" />
                      Sort by A-Z
                    </Link>
                    <ul className="dropdown-menu p-3">
                      <li>
                        <Link to="#" className="dropdown-item rounded-1 active">
                          Ascending
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Descending
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Recently Viewed
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Recently Added
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="card-body p-0 py-3">
                {/* Guardians List */}
                <Table columns={columns} dataSource={classrooms} Selection={true} />

                {/* /Guardians List */}
              </div>
            </div>
            {/* /Guardians List */}
          </div>
        </div>
        {/* /Page Wrapper */}
      </>
      <div>
        <Modal show={showModal} onHide={handleClose} size={"xl"}>
          <Modal.Header >
            <Modal.Title>Add Application</Modal.Title>
            <button
              type="button"
              className="btn-close custom-btn-close"
              onClick={handleClose}

            >
              <i className="ti ti-x" />
            </button>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="d-flex align-items-center flex-wrap row-gap-3 mb-3">
                      <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                        <i className="ti ti-photo-plus fs-16" />
                      </div>
                      <div className="profile-upload">
                        <div className="profile-uploader d-flex align-items-center">
                          <div className="drag-upload-btn mb-3">
                            Upload
                            <input
                              type="file"
                              className="form-control image-sign"
                              multiple
                            />
                          </div>
                          <Link to="#" className="btn btn-primary mb-3">
                            Remove
                          </Link>
                        </div>
                        <p className="fs-12">
                          Upload image size 4MB, Format JPG, PNG, SVG
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">

                  <div className="col-md-3">
                    <div className="mb-3">
                      <label className="form-label">Title</label>
                      <select

                        className="select react-select form-control"
                        name="title_id"
                        onChange={handleInputChange}
                      >
                        <option >Select Title</option>
                        {partnerTitle && partnerTitle?.map((item: any) => (
                          <option key={item.id} value={item.id}>{item.name}</option>
                        ))}

                      </select>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="mb-3">
                      <label className="form-label">First Name</label>
                      <input type="text" className="form-control" placeholder="First Name" name="first_name" value={formData.first_name}
                        onChange={handleInputChange} />
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="mb-3">
                      <label className="form-label">Middle Name</label>
                      <input type="text" className="form-control" placeholder="Middle Name" name="middle_name" value={formData.middle_name}
                        onChange={handleInputChange} />
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="mb-3">
                      <label className="form-label">Last Name</label>
                      <input type="text" className="form-control" placeholder="Last Name" name="last_name" value={formData.last_name}
                        onChange={handleInputChange} />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">Gender</label>
                      <select

                        className="select react-select form-control"
                        name="gender"
                        onChange={handleInputChange}
                      >
                        <option >Select Gender</option>

                        <option value="m">Male</option>
                        <option value="f">Female</option>


                      </select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">Email</label>
                      <input type="email" className="form-control" name="email"
                        //  value={formData.email}
                        onChange={handleInputChange} placeholder="Email" />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">Birth Date</label>
                      <input type="date" className="form-control" name="birth_date"
                        onChange={handleInputChange} placeholder="Birth date" />
                    </div>


                  </div>


                </div>





                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">	Fees Term</label>
                      <select

                        className="select react-select form-control"
                        name="fees_term_id"
                        onChange={handleInputChange}
                      >
                        <option >Select Fees Term</option>
                        {opFeesTerms && opFeesTerms?.map((item: any) => (
                          <option key={item.id} value={item.id}>{item.name}</option>
                        ))}

                      </select>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">	Admission Register</label>
                      <select

                        className="select react-select form-control"
                        name="register_id"
                        onChange={handleInputChange}
                      >
                        <option >Select Register</option>
                        {admissionRegisters && admissionRegisters?.map((item: any) => (
                          <option key={item.id} value={item.id}>{item.name}</option>
                        ))}

                      </select>
                    </div>
                  </div>
                </div>



              </div>
              <div className="modal-footer">
                <span
                  className="btn btn-light me-2"
                  onClick={handleClose}
                >
                  Cancel
                </span>
                <a className="btn btn-primary" onClick={handleSubmit}>
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm align-middle me-1"
                        role="status"
                        aria-hidden="true"
                      />
                      Loading...
                    </>
                  ) : "Add Application"}

                </a>
              </div>
            </form>
          </Modal.Body>

        </Modal>

        <Toast
          show={showDangerToast}
          onClose={handleDangerToastClose}
          id="dangerToast"
          className="toast-container position-fixed top-0 end-0 p-3 colored-toast bg-danger-transparent"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          style={{ minWidth: "200px!important" }}
        >
          <Toast.Header closeButton className="bg-danger text-fixed-white">
            <strong className="me-auto">Message</strong>
            <span
              className="cursor-pointer"
              onClick={handleDangerToastClose}
              aria-label="Close"
              style={{ cursor: "pointer" }}
            />
          </Toast.Header>
          <Toast.Body>
            {/* Add your toast content here */}
            {errorMessage}
          </Toast.Body>
        </Toast>

        <Toast
          show={showSuccessToast}
          onClose={handleSuccessToastClose}
          id="successToast"
          className="toast-container position-fixed top-0 end-0 p-3  colored-toast bg-success-transparent"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >

          <Toast.Body>
            {/* Add your toast content here */}
            {successMessage}
          </Toast.Body>
        </Toast>
      </div>
    </div>
  );
};

export default ClassRoomDetails;
